import React from 'react';

import { DisplayName } from '../../DisplayName';
import Browser from '@wetransfer/transfer/modules/concorde-browser';

import { TitleProps } from './types';

export const Title: React.FC<TitleProps> = React.memo(function Title({
  hasMessage,
  content,
}) {
  if (Browser.isMobile) {
    return <DisplayName hasMessage={hasMessage} content={content} />;
  }

  return <h2>{content}</h2>;
});
